export default {
      id: "i-menu-solutions-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-solutions",
      toString: function () {
        return this.url;
      }
    }